import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import { actions } from 'react-redux-form/immutable'
import Loading from 'bisu-react-loading'

import FormContainer from './form-container'

class PaymentsNew extends Component {

  componentDidMount() {
    const { dispatch, __session, __nextOrno } = this.props
    dispatch(actions.reset('paymentState'))
    dispatch(actions.change('paymentState.sy', __session.get('sy')))
    dispatch(actions.change('paymentState.sem', __session.get('sem')))
    dispatch(actions.change('paymentState.orno', __nextOrno.toString()))
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.__nextOrno !== 0) {
      this.props.dispatch(actions.change('paymentState.orno', nextProps.__nextOrno.toString()))
    }
  }

  render() {
    const { __lastOrnoHasFetched, onSearchForm } = this.props
    if (!__lastOrnoHasFetched) {
      return <Loading />
    }

    return (
      <FormContainer onSearchForm={onSearchForm} isNew />
    )
  }
}

PaymentsNew.propTypes = {
  __session: PropTypes.object,
  dispatch: PropTypes.func,
}

function mapStateToProps(state) {
  return {
    __session: state.auth.get('session'),
    __nextOrno: state.payment.get('lastorno') + 1,
    __lastOrnoHasFetched: state.payment.get('lastornoHasFetched'),
  }
}

export default connect(mapStateToProps)(PaymentsNew)



// WEBPACK FOOTER //
// ./src/containers/Payments/new.js